/**
 * @description renders a select box for each personnel listed in the personnel list
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { DateTime } from 'luxon';
import Checkbox from '@mui/material/Checkbox';
import { STATUSES } from '../constants';

const SelectBox = ({ personnelId, index }) => {
  const { getValues, setValue, watch } = useFormContext();
  const selectedPersonnel = watch('selectedPersonnel');

  /**
   * Handles checkbox check events by adding this personnel's id to the list of selected personnel or removes it
   * @param {boolean} checked - checkbox state
   */
  function handleChange (checked) {
    const newSelectedPersonnel = { ...selectedPersonnel };
    const [currDateAssigned, currStatus] = getValues([`personnel.${ index }.dateAssigned`, `personnel.${ index }.status`]);
    let dateAssigned = null;
    let status = null;

    // If checked, add it to the list. If unchecked, remove it from the list
    if (checked) {
      newSelectedPersonnel[personnelId] = true;
      dateAssigned = currDateAssigned ?? DateTime.now();
      status = currStatus ?? STATUSES[1];
    } else {
      delete newSelectedPersonnel[personnelId];
    }

    setValue('selectedPersonnel', newSelectedPersonnel, { shouldDirty: true, shouldValidate: true });
    setValue(`personnel.${ index }.status`, status, { shouldDirty: true });
    setValue(`personnel.${ index }.dateAssigned`, dateAssigned, { shouldDirty: true });
  }

  return (
    <Checkbox
      onChange={(evt) => handleChange(evt.target.checked)}
      checked={Boolean(selectedPersonnel[personnelId])}
    />
  );
};

SelectBox.propTypes = {
  personnelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  index: PropTypes.number.isRequired
};

export default SelectBox;
